import type { GraphQLErrorPayload as GraphQLErrorInterop } from '@confluence/relay-errors/entry-points/RelayError.ts';

import { createEditorContentUnifiedQueryVariables } from '@confluence/editor-content-unified-query/entry-points/createEditorContentUnifiedQueryVariables.ts';
import { expValEquals } from '@confluence/feature-experiments';
import { query } from '@confluence/query-preloader-tools/entry-points/graphql.ts';

import { queryStatusFor } from '../utils/contentMode.ts';
import UseEditorContentModeValueQuery, {
	type useEditorContentModeValueQuery$data,
	type useEditorContentModeValueQuery$variables,
} from '../hooks/__generated__/useEditorContentModeValueQuery.graphql.ts';

export const preloadContentMode = ({
	contentId,
	isDraft,
	useCache = false,
	isArchived,
}: {
	contentId: useEditorContentModeValueQuery$variables['contentId'];
	isDraft: useEditorContentModeValueQuery$variables['isDraft'];
	useCache: boolean;
	isArchived?: boolean;
}): Promise<{
	data: useEditorContentModeValueQuery$data | null;
	errors?: ReadonlyArray<GraphQLErrorInterop>;
	hasErrors: boolean;
}> => {
	const status = queryStatusFor(isDraft, isArchived);

	return query<useEditorContentModeValueQuery$data, useEditorContentModeValueQuery$variables>({
		query: UseEditorContentModeValueQuery,
		variables: expValEquals('confluence_editor_content_unified_query', 'isEnabled', true)
			? { ...createEditorContentUnifiedQueryVariables({ contentId }), isDraft }
			: {
					contentId,
					isDraft,
					status: [status],
				},
		fetchPolicy: useCache ? 'cache-first' : 'network-only',
	});
};
